<template>
<div id="solidBackground" :style="{ position: position, height: `${height}px` }">
    <div v-scroll="onScroll" :style="{
        transform: `rotate(${rotate}deg)`,
        top: `${top}vh`,
        left: `-${left}%`,
        height: `${height}px`,
        transitionDuration: `${animTime.present}s`,
      }"></div>
</div>
</template>

<script>
export default {
    data() {
        return {
            rotate: 5,
            height: 0,
            width: 0,
            position: "absolute",
            top: 88,
            left: 50,
            animDone: false,
            animTime: {
                present: 0,
                in: 3,
                out: 1.5,
            },
        };
    },
    methods: {
        onScroll(e) {
            if (typeof window === "undefined" || this.isMobile) return;
            const top = window.pageYOffset || e.target.scrollTop || 0;
            if (top > window.innerHeight / 2) {
                if (this.animDone) return;
                this.animDone = true;
                this.rotate = 180;
                this.top = -5;
                this.animTime.present = this.animTime.in;
                setTimeout(() => {
                    if (this.animDone) {
                        this.rotate = 206;
                        this.top = 70;
                        this.left = 80;
                        this.position = "fixed";
                    }
                }, this.animTime.in * 1000);
            } else {
                if (!this.animDone) return;
                this.animDone = false;
                this.rotate = 5;
                this.top = 0;
                this.animTime.present = this.animTime.out;
                setTimeout(() => {
                    if (!this.animDone) {
                        this.position = "absolute";
                        this.top = 88;
                        this.left = 50;
                    }
                }, this.animTime.out * 1000);
            }
        },
    },
    mounted() {
        this.height = document.body.scrollHeight;
        this.width = screen.width;
        if (this.$isMobile) {
            this.left = 100;
        }
    },
    computed: {
        isMobile() {
            return this.$store.getters.isMobile;
        },
    },
};
</script>

<style lang="scss" scoped>
#solidBackground {
    display: flex;
    justify-content: center;
    align-items: center;
    overflow: hidden;
    width: 100vw;
    height: 200vh;
    position: absolute;

    div {
        background: #002a6b;
        width: 8000px;
        height: 2000px;
        position: absolute;
        transform: rotate(3deg);
        top: 88vh;
        left: -50%;
        overflow: hidden;
        opacity: 0.82;
        transition: all cubic-bezier(0.46, 0.02, 0.21, 0.98);
    }
}
</style>
\
